import { trpcUtils } from './trpc';

/**
 * Marks everything derived from documents and folders as stale: the KB tables,
 * stats and detail views, plus the chat queries whose per-agent document counts
 * are computed from them. Active queries refetch, inactive ones on next mount.
 */
export function invalidateKB() {
  return invalidateKBQueries({ refetchChatDetails: true });
}

export function invalidateKBAfterChatDeletion() {
  return invalidateKBQueries({ refetchChatDetails: false });
}

function invalidateKBQueries({
  refetchChatDetails,
}: {
  refetchChatDetails: boolean;
}) {
  return Promise.all([
    trpcUtils.documentFolders.findAll.invalidate(),
    trpcUtils.documentFolders.findContents.invalidate(),
    trpcUtils.documentFolders.getBreadcrumbs.invalidate(),
    trpcUtils.documentFolders.findOne.invalidate(),
    trpcUtils.documents.findAll.invalidate(),
    trpcUtils.documents.findOne.invalidate(),
    trpcUtils.documents.getStats.invalidate(),
    trpcUtils.chats.findAll.invalidate(),
    trpcUtils.chats.findOne.invalidate(undefined, {
      refetchType: refetchChatDetails ? 'active' : 'none',
    }),
  ]);
}
